import {
  actionCreator,
  persistentReducedStream,
  reducer,
} from '@ardoq/rxbeach';
import { type Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import type { I18nLocale } from '@ardoq/i18n';
import type { SlideProgress } from './slidePlan';

export type PptxExportState =
  | { status: 'idle' }
  | ({ status: 'capturing' } & SlideProgress)
  | { status: 'building'; total: number };

export const pptxExportRequested = actionCreator<{ i18nLocale: I18nLocale }>(
  '[pptxExport] Requested'
);

export const pptxExportSlideStarted = actionCreator<SlideProgress>(
  '[pptxExport] Slide started'
);
export const pptxExportDeckBuildStarted = actionCreator(
  '[pptxExport] Deck build started'
);
export const pptxExportCancelRequested = actionCreator(
  '[pptxExport] Cancel requested'
);
export const pptxExportEnded = actionCreator('[pptxExport] Ended');

const IDLE: PptxExportState = { status: 'idle' };

export const isPptxExportRunning = (state: PptxExportState): boolean =>
  state.status !== 'idle';

const startSlide = (
  _state: PptxExportState,
  progress: SlideProgress
): PptxExportState => ({ status: 'capturing', ...progress });

const startDeckBuild = (state: PptxExportState): PptxExportState =>
  state.status === 'capturing'
    ? { status: 'building', total: state.total }
    : state;

const endExport = (): PptxExportState => IDLE;

export const pptxExport$ = persistentReducedStream('pptxExport$', IDLE, [
  reducer(pptxExportSlideStarted, startSlide),
  reducer(pptxExportDeckBuildStarted, startDeckBuild),
  reducer(pptxExportEnded, endExport),
]);

export const isPptxExportRunning$: Observable<boolean> = pptxExport$.pipe(
  map(isPptxExportRunning),
  distinctUntilChanged()
);
